import { render } from "./Insights.vue?vue&type=template&id=6bc1431c&lang=pug"
import script from "./Insights.vue?vue&type=script&setup=true&lang=js"
export * from "./Insights.vue?vue&type=script&setup=true&lang=js"

import "./Insights.vue?vue&type=style&index=0&id=6bc1431c&lang=sass"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__